import config from '@/config';
import { fetchData } from '@/model/utils/fetch';

export const fetchStrikeGoldData = async ({
  market_country,
}: {
  market_country?: string;
}) => {
  try {
    const response = await fetchData<Record<string, any>>({
      url: `${config.urls.bffBaseUrl}/strike-gold`,
      queryParameters: {
        market_country,
      },
    });

    return {
      status: 200,
      data: response || {},
    };
  } catch (err) {
    console.error(
      `There was a problem while fetching strike gold data. ${config.urls.bffBaseUrl}/strike-gold.`
    );
    console.error(err);

    // @ts-ignore
    return { status: err.status, data: [] };
  }
};
